import type { SectionKey } from '../api/navigation.ts';
import type { Department } from '../api/taskQueries.ts';

/**
 * The department each client section records an action for (A-#144): Social Work, Finance, Legal, Property, and
 * Compliance in Reports. The other sections record none.
 */
export const SECTION_DEPARTMENT: Partial<Record<SectionKey, Department>> = {
  sw: 'Social Work', financials: 'Finance', legal: 'Legal', property: 'Property', reports: 'Compliance',
};

/**
 * The department this section offers "Record an action" in, or null: only one the reader holds, as the server's
 * `action` list says (GET /tasks/departments: their own, or all five for tiers 1-2 and the Executive Case Reviewer).
 */
export function sectionActionDepartment(section: SectionKey, action: readonly Department[] | undefined): Department | null {
  const d = SECTION_DEPARTMENT[section];
  return d !== undefined && (action ?? []).includes(d) ? d : null;
}
